var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0095DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_24759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.825 11.8167L20.4084 6.1918C20.2317 6.00763 19.9608 5.95026 19.7251 6.04517C19.4884 6.14099 19.3334 6.37018 19.3334 6.62515V9.33356H19.1251C14.6452 9.33356 11.0002 12.9785 11.0002 17.4585V18.7085C11.0002 18.9984 11.2044 19.2401 11.4868 19.3058C11.5326 19.3167 11.5785 19.3226 11.6243 19.3226C11.8609 19.3226 12.0868 19.1842 12.1951 18.9676C13.3668 16.6234 15.7226 15.1668 18.3434 15.1668H19.3334V17.875C19.3334 18.13 19.4884 18.3592 19.7251 18.455C19.9592 18.5493 20.2317 18.4926 20.4084 18.3084L25.825 12.6834C26.0583 12.4417 26.0583 12.0584 25.825 11.8167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.5001 25.9999H8.50023C7.12191 25.9999 6.00025 24.8782 6.00025 23.4999V11.8335C6.00025 10.4552 7.12191 9.3335 8.50023 9.3335H11.0002C11.461 9.3335 11.8335 9.70672 11.8335 10.1668C11.8335 10.6268 11.461 11 11.0002 11H8.50023C8.04018 11 7.6668 11.3742 7.6668 11.8335V23.4999C7.6668 23.9591 8.04018 24.3333 8.50023 24.3333H23.5001C23.96 24.3333 24.3334 23.9591 24.3334 23.4999V16.8334C24.3334 16.3734 24.7058 16 25.1666 16C25.6274 16 26.0001 16.3734 26.0001 16.8334V23.4999C26.0001 24.8782 24.8784 25.9999 23.5001 25.9999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_24759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.62c04136b1728ed0c36692f1197b0d6b.svg";
export { ForwardRef as ReactComponent };